let app = require("../app"),
    View = require("./ContactForm");

app.on("start", function (options) {
    new View(options);
});
